import { useMemo } from 'react'
import useJobCategoryStore from '../store/store.jobCategory'

const useSelectedCategories = () => {
  const showSelectedIds = useJobCategoryStore((state) => state.showSelectedIds)
  const getCategoriesByIds = useJobCategoryStore(
    (state) => state.getCategoriesByIds,
  )

  const selectedCategories = useMemo(
    () => getCategoriesByIds(showSelectedIds),
    [showSelectedIds],
  )

  return { selectedCategories }
}

export default useSelectedCategories
